export default function Footer() {
  return (
    <footer className="bg-zinc-950 border-t border-zinc-800 py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/8247d44a15513d6329a08a3e6e69b51d/cc8a12b5bf00968df136d32511045f2c.png" 
                alt="MR Prime Ops Logo" 
                className="h-10 w-10 object-contain"
              />
              <span className="text-xl font-bold">MR Prime Ops</span>
            </div>
            <p className="text-sm text-gray-400 mb-4">
              Operational excellence, executed quietly.
            </p>
            <p className="text-sm text-cyan-400 font-mono">
              mrprimeops.com
            </p>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-bold mb-4 uppercase tracking-wider">Contact</h3>
            <div className="space-y-3">
              <a href="mailto:matheus.rondinelli@mrprimeops.com" className="text-sm text-gray-400 hover:text-cyan-400 transition-colors flex items-center gap-2 cursor-pointer">
                <i className="ri-mail-line"></i>
                matheus.rondinelli@mrprimeops.com
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-zinc-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-500">
            © 2025 MR Prime Ops. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-sm text-gray-500 hover:text-cyan-400 transition-colors cursor-pointer"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
